<script>
  import Contained from '../components/button-contained.svelte'
  import Outlined from '../components/button-outline.svelte'
  import StoryHeader from '../components/story-header.svelte'
  import {
    push
  } from 'svelte-spa-router'
  export let id, title, distance, length, image, summary, description;

  function begin(event) {
    push(`#/story/${event.detail.ref}`);
  }
</script>

<div style="max-width:370px; margin: 0 auto;" class="card four-secondary">
  <StoryHeader {title} {distance} {length} />
  <div class="placeholder">
    <img src="{image + '.jpg'}" srcset="{image + '.jpg'} 1x, {image + 'X2.jpg'} 2x" alt="">
  </div>
  <p class="body-2">{summary}</p>
  <Contained ref="{id}" on:pressed="{begin}" text=Begin />
  <Outlined ref="{id}" on:pressed="{begin}" text="More Info" />
</div>

<style>
  img {
    width: 100%;
    height: 100%;
  }

  .placeholder {
    width: calc(100% + 40px);
    height: 288px;
    background-color: #c9c9c9;
    margin-left: -20px;
  }
</style>
